import { Component, Input, OnInit } from '@angular/core';
import { BreadcrumbComponent } from '../../../../shared/components/breadcrumb/breadcrumb.component';
import { CommonModule } from '@angular/common';
import { IPolicyResponse } from '@interfaces/policy-response.interface';
import { InsuranceService } from 'src/app/core/services/insurance.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/services/auth.service';
import { DataService } from 'src/app/core/services/data.service';
import { ModalAlreadyCancelledComponent } from '../../components/modal-already-cancelled/modal-already-cancelled.component';
import { ModalCancelPolicyComponent } from '../../components/modal-cancel-policy/modal-cancel-policy.component';
import { ModalNewClaimComponent } from '../../components/modal-new-claim/modal-new-claim.component';
import { ModalRejectedComponent } from '../../components/modal-rejected/modal-rejected.component';
import { IValidarSiniestro } from '@interfaces/validar-siniestro.interface';
import { ISiniestroRequest } from '@interfaces/siniestro-request.interface';

@Component({
  selector: 'aig-policy-details',
  imports: [
    CommonModule,
    ModalCancelPolicyComponent,
    ModalAlreadyCancelledComponent,
    ModalRejectedComponent,
    ModalNewClaimComponent,
    BreadcrumbComponent,
  ],
  templateUrl: './policy-details.component.html',
  styleUrl: './policy-details.component.scss',
})
export class PolicyDetailsComponent implements OnInit {
  //#region Variables
  public cancelModalVisible: boolean = false;
  public alreadyCancelled: boolean = false;

  public policyResponse: IPolicyResponse | null = null; // La póliza obtenida previamente

  public rejectedClaimModalVisible: boolean = false;
  public visibleNewClaimModal: boolean = false;

  public policy: IPolicyResponse | undefined;
  public IdPoliza: number | undefined;

  resultado?: IValidarSiniestro;

  //#endregion
  constructor(
    private insuranceService: InsuranceService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const navigation = history.state;
    this.policy = navigation.policy;
    console.log(this.policy);
    this.IdPoliza = this.policy?.idPoliza;
  }

  policyState(arg: number | undefined): string {
    switch (arg) {
      case 1:
        return '';
      case 2:
        return 'cancel';
      case 3:
        return 'inactive';
      case 5:
        return 'inactive';
      case 6:
        return 'inactive';
      default:
        return '';
    }
  }

  download() {
    console.log(this.IdPoliza);
    if (this.IdPoliza) {
      this.insuranceService
        .descargarFicheroPoliza(this.IdPoliza)
        .subscribe((res: any) => {
          const byteCharacters = atob(res.fileContents);
          const byteNumbers = new Array(byteCharacters.length);

          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: res.contentType });
          const fileName = `CONDICIONES_PARTICULARES_${
            this.policy?.num_Poliza ?? ''
          }.pdf`;

          const objectUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = objectUrl;
          a.download = fileName;
          a.click();
          URL.revokeObjectURL(objectUrl);
        });
    }
  }

  public CloseNewClaim() {
    this.visibleNewClaimModal = false;
  }

  onCloseModalCancelation(cancelado: boolean): void {
    this.cancelModalVisible = false;

    if (cancelado) {
      location.reload(); // Recarga la página si la cancelación fue enviada con éxito
    }
  }

  onCloseModalRejectedClaim(): void {
    this.rejectedClaimModalVisible = false;
  }

  //#region Navigation
  public goToModifyPolicy(): void {
    this.router.navigate(['/area-cliente/modificar-datos'], {
      state: { policy: this.policy },
    });
    location.replace('/area-cliente/modificar-datos');
  }

  public abrirSiniestroRechazado(data: IValidarSiniestro) {
    const request: ISiniestroRequest = {
      idPoliza: data.idPoliza,
      puedeAbrirSiniestro: false,
      siniestroCurso: data.siniestroCurso,
      estadoPoliza: data.estadoPoliza,
    };

    console.log(request);

    this.insuranceService.aperturaSiniestro(request).subscribe({
      next: (response) => {
        console.log('Respuesta:', response);
        // this.isloading = false;
      },
      error: (err) => {
        console.log('Error:', err);
        // this.isloading = false;
        // this.submiterror = 'ha ocurrido un error, por favor revisa los datos e inténtalo de nuevo.';
        // puedes mostrar el error en el template
      },
    });
  }

  public goToClaimsManagement(): void {
    if (this.IdPoliza === null) {
      console.error('Error: IdPoliza es null');
      return; // No continuar si es null
    }
    if (this.IdPoliza) {
      this.insuranceService
        .validarAperturaSiniestro(this.IdPoliza)
        .subscribe((data) => {
          this.resultado = data;
          if (this.resultado.existenSiniestros == true) {
            this.router.navigate(['/area-cliente/gestion-siniestros']);
            //location.replace('/area-cliente/gestion-siniestros');
          } else if (
            this.resultado.estadoPoliza == 1 &&
            this.resultado.siniestroCurso == false &&
            this.resultado.existenSiniestros == false
          ) {
            this.visibleNewClaimModal = true;
          } else {
            this.abrirSiniestroRechazado(data);
            this.rejectedClaimModalVisible = true;
            // resultado.existenSiniestros está disponible aquí
          }
        });
    }
  }
  //#endregion
}
